module.exports = {
    host: "https://bkabu.vastok.uz",
    // host: "http://localhost:8000",
    // host: "https://backend.gold-uz.uz",
};
